import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, Modal } from 'react-bootstrap';
import Photo1 from '../Medias/Photos/Pic3.jpg';

const SectionAbout = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <section id="about" className='pt-5 pb-5'>
      <Container className='pt-5 pb-5'>
        <Row>
          <Col sm={12} md={6}>
            <img src={Photo1} className='w-100' />
          </Col>
          <Col sm={12} md={6} className='pb-5 ps-5 pe-5'>
            <div className='pb-5 pt-5'>
              <h3 className='font-header mb-3'>About Us</h3>
              <p>PT & Associates was founded in 2015 as PJT Law that was established as a legal think tank concentrating on multi-disciplinary legal research on a wide spectrum of contemporary Thai legal topics. The Law Firm initially focused its research expertise on constitutional and human rights subjects for domestic and international audiences, and later expanded to administrative and governmental regulatory compliance. The Law Firm’s practice expanded into advising government agencies, such as translating aviation laws and regulations of the Civil Aviation Authority of Thailand (CAAT) for the International Civil Aviation Organization (ICAO). In 2021, the Law Firm was renamed as PT & Associates corresponding to its growing team of professionals with diverse experience and competencies.
              </p>
              <Button variant='' color='color-primary' className='bg-color-primary text-white border-0 px-4' as={Link} to="/About">Read More</Button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SectionAbout;
